<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="scaleForm" class="col-12">
            <!-- Hidden Inputs for ID -->
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'scaleId'" hidden>

            <div class="row p-0">
                <div class="col-6 input-box" *ngIf="data.dailyRate === false">
                    <mat-form-field appearance="outline">
                        <mat-label>Rate Per Period</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'RAMP_Rate_Per_Period'" pattern="^[0-9]+(\.[0-9]*)?$" required>
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Monthly Rate</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'RAMP_Monthly_Rate'" pattern="^[0-9]+(\.[0-9]*)?$" required>
                    </mat-form-field>
                </div>
            </div>
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Daily Rate</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed." [formControlName]="'Amount'"
                            pattern="^[0-9]+(\.[0-9]*)?$">
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Hourly Rate</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'RAMP_Amount2'" pattern="^[0-9]+(\.[0-9]*)?$">
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field>
                        <mat-label>Minute Rate</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'RAMP_Amount3'" pattern="^[0-9]+(\.[0-9]*)?$" required>
                    </mat-form-field>
                </div>
            </div> -->
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline" >
                        <mat-label>Minute Rate</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'RAMP_Amount3'" pattern="^[0-9]+(\.[0-9]*)?$">
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Hours Per Day</mat-label>
                        <input matInput placeholder="e.g. 8" type="text"
                            matTooltip="Number of working hours per day."
                            [formControlName]="'RAMP_Hours_Per_Day'" pattern="^[0-9]+(\.[0-9]*)?$" required>
                    </mat-form-field>
                </div>
            </div>
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline" hidden>
                        <mat-label>Min. Value</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'MinValue'" pattern="^[0-9]+(\.[0-9]*)?$" hidden>
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline" hidden>
                        <mat-label>Max. Value</mat-label>
                        <input matInput placeholder="Enter Charge Amount" type="text"
                            matTooltip="Enter a valid amount. Decimal values are allowed."
                            [formControlName]="'MaxValue'" pattern="^[0-9]+(\.[0-9]*)?$" hidden>
                    </mat-form-field>
                </div>
            </div>
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Valid From:</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="ValidFrom"
                            matTooltip="Valid from including this date (first day).">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                            [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Valid To:</mat-label>
                        <input matInput [matDatepicker]="picker2" formControlName="ValidTo"
                            matTooltip="Valid to including this date (last day).">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                            [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="scaleForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>